import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import useOnClickOutside from "hooks/useOnClickOutside";
import CategoryDropdown from "components/Header/MainHeader/SearchProducts/CategoryDropdown";
import {
  getSearchResultList,
  updateSearchText,
  updateSearchType,
  updateNodeFuctionalText,
  updateNodeFunctionalLevel,
  resetFilterSideBar,
  emptyIftCheckList,
  updateSortByValue,
  updatePageLimit,
  getCouponDetailsAPI,
} from "redux/actions";
import _ from "lodash";
import SearchDropdown from "./SearchDropdown";
import SearchIcon from "assets/icons/search.svg";
import DownIcon from "assets/icons/down.svg";
import { useNavigate } from "react-router-dom";
import { getLocalStorageValue } from "config/helper";
import { useLocation } from "react-router-dom";

const SearchProducts = () => {
  const refSearchTypeDropdown = useRef();
  const navigate = useNavigate();
  let urlParams = new URLSearchParams(window.location.search);
  let searchValue = urlParams.get("s");

  const refSearchDropdown = useRef();
  const dispatch = useDispatch();
  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");

  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);
  const { currentDepartment } = useSelector(({ product }) => product);
  const {
    ecom_section: { allow_ecommerce = "" },
    reorder_section: { has_visible_reorder_menu },
  } = useSelector(({ common }) => common.commonDetailsData);

  const searchTypeDropDownOption = useSelector(
    ({ common }) => common.commonDetailsData.top_dropdown_section
  );

  const [isShowSearchDropdown, setIsShowSearchDropdown] = useState(false);
  const [isShowSearchTypeDropdown, setIsShowSearchTypeDropdown] =
    useState(false);
  const [searchedText, setSearchedText] = useState("");

  let ecomSearchTypeDropDownOption =
    allow_ecommerce === "0"
      ? // && has_visible_reorder_menu === "0"
      searchTypeDropDownOption?.filter(
        (each) => each.search_type !== "products"
      )
      : searchTypeDropDownOption;

  const { searchResultList, searchResultListLoading, searchType, searchText } =
    useSelector(({ search }) => search);

  useOnClickOutside(refSearchTypeDropdown, () =>
    setIsShowSearchTypeDropdown(false)
  );
  useOnClickOutside(refSearchDropdown, () => setIsShowSearchDropdown(false));

  useEffect(() => {
    if (currentDepartment) {
      dispatch(updateSearchType(currentDepartment));
      dispatch(updateSearchText(""));
    }
  }, [currentDepartment]); // eslint-disable-line

  useEffect(() => {
    if (allow_ecommerce === "0") {
      dispatch(updateSearchType("coupons"));
    } else {
      dispatch(updateSearchType("products"));
    }
  }, [dispatch, allow_ecommerce]); // eslint-disable-line
  const { pathname } = useLocation();

  useEffect(() => {
    if (allow_ecommerce === "0") {
      dispatch(updateSearchType("coupons"));
    } else {
      dispatch(updateSearchType("products"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (searchValue !== null && searchValue !== undefined) {
      setSearchedText(searchText);
    } else {
      setSearchedText("");
      dispatch(updateSearchText(""));
    }
  }, [searchText, searchValue]);

  const handlechange = (e) => {
    setSearchedText(e.target.value);
    if (e.target.value) {
      getSearchResult.current(e.target.value);
    }
  };

  const getSearchResult = useRef(
    _.debounce((searchedText) => {
      const body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        search: searchedText,
        AppName: isUserLoggedIn ? "shop" : "",
        member_number: isUserLoggedIn ? memberNumber : "",
        user_token: isUserLoggedIn ? userToken : "",
        Version: isUserLoggedIn ? "1" : "",
        DeviceType: isUserLoggedIn ? "web" : "",
      };
      if (allow_ecommerce === "1") {
        dispatch(getSearchResultList(body));
        setIsShowSearchDropdown(true);
      }
    }, 500)
  );

  const handleToggleCategoyDropdown = () => {
    setIsShowSearchTypeDropdown(!isShowSearchTypeDropdown);
  };

  const handleChangeSelectedOption = (optionValue) => {
    if (!isUserLoggedIn && optionValue === "list-items") {
      navigate(`/login`);
    } else {
      setIsShowSearchTypeDropdown(false);
      dispatch(updateSearchType(optionValue));
      dispatch(updateNodeFuctionalText(""));
      dispatch(updateNodeFunctionalLevel(""));
      dispatch(resetFilterSideBar());
      dispatch(updateSearchText(""));
      if (["products", "coupons"].includes(optionValue)) {
        navigate(`/search/${optionValue}/`);
      } else {
        navigate(`/departments/${optionValue}`);
      }
    }
  };

  const { sub_department = [] } = useSelector(
    ({ common }) => common.commonDetailsData.ecom_section || {}
  );

  let ecomSearchOptions = [...ecomSearchTypeDropDownOption];

  if (!!sub_department.length) {
    const updatedSubDepartment = sub_department.map((sub) => {
      return {
        ...sub,
        search_type: sub.slug,
      };
    });
    ecomSearchOptions.splice(1, 0, updatedSubDepartment);
    ecomSearchOptions = ecomSearchOptions.flat();
  } else {
    ecomSearchOptions = ecomSearchTypeDropDownOption;
  }
  const selectedSearchType =
    ecomSearchOptions &&
    ecomSearchOptions.find((type) => type.search_type === searchType);

  const categoryNameList = ecomSearchTypeDropDownOption.map(
    (cat) => cat.search_type
  );

  const onSearchChange = (keyword) => {
    let queryParams = `?s=${keyword}`;
    if (categoryNameList.includes(searchType)) {
      navigate(`/search/${searchType}${queryParams}`);
    } else {
      navigate(`/departments/${searchType}${queryParams}`);
    }
    dispatch(updateSearchText(keyword));
  };

  const handleSearchbox = (e) => {
    const { value } = e.target;
    if (e.key === "Enter") {
      let queryParams = `?s=${value}`;
      let body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        SearchValue: searchedText,
        UserToken: isUserLoggedIn ? userToken : "",
      };
      // dispatch(getCouponDetailsAPI(body));
      dispatch(updateSearchText(value));
      navigate(`/search/coupons${queryParams}`);
    }
  };
  // ticket no:1791  clicking on search icon , search operation is working. completed on 2/22/2023 - Navina.k
  const handleSearchImage = () => {
    let searchValue = searchedText;
    let queryParams = `?s=${searchValue}`;
    if (allow_ecommerce === "1") {
      dispatch(emptyIftCheckList());
      dispatch(updateSortByValue(""));
      // dispatch(updatePageLimit(value));
      if (categoryNameList.includes(searchType)) {
        navigate(`/search/${searchType}${queryParams}`);
      } else {
        navigate(`/search/products${queryParams}`);
      }
      dispatch(updateSearchText(searchValue));
      setIsShowSearchDropdown(true);
    } else {
      let body = {
        RSAClientId: clientId,
        ClientStoreId: +storeId || 1,
        SearchValue: searchedText,
        UserToken: isUserLoggedIn ? userToken : "",
      };
      // dispatch(getCouponDetailsAPI(body));
      dispatch(updateSearchText(searchValue));
      navigate(`/search/coupons${queryParams}`);
    }
  };

  return (
    <div className="search-products-wrapper search-form-group">
      {/* <div
        className="categories"
        onClick={() => handleToggleCategoyDropdown()}
        ref={refSearchTypeDropdown}>
        <span>{selectedSearchType ? selectedSearchType.name : ""}</span>
        <img src={DownIcon} alt="DownIcon" />

        <CategoryDropdown
          isShow={isShowSearchTypeDropdown}
          onClose={() => setIsShowSearchTypeDropdown(false)}
          dropdownData={ecomSearchOptions}
          onSelectOption={handleChangeSelectedOption}
          selectedSearchType={
            selectedSearchType && selectedSearchType.search_type
          }
        />
      </div> */}
      <div
        className="mobile-header-search-products-wrapper"
        ref={refSearchDropdown}
        onClick={() => {
          setIsShowSearchDropdown(!isShowSearchDropdown);
        }}
      >
        <div className="relative-div">
          <input
            type="text"
            // placeholder={`${selectedSearchType?.name ?? ""}`}
            placeholder="Search Coupons"
            onChange={handlechange}
            onKeyPress={handleSearchbox}
            value={searchedText}
          />
          <img
            src={SearchIcon}
            className="search-img"
            alt="SearchIcon"
            onClick={handleSearchImage}
          />
          <div
            className="icon-wrapper"
            onClick={handleSearchImage}
            style={{ cursor: "pointer" }}
          >
            <div className="search-text">
              <span>Search</span>
            </div>
          </div>

          {searchResultList.length ? (
            <div
              className={
                isShowSearchDropdown
                  ? "search-dropdown dropdown-show"
                  : "search-dropdown dropdown-hidden"
              }
            >
              <div className="list-menu">
                <ul>
                  {searchResultList.map((product) => {
                    return (
                      <SearchDropdown
                        key={product.keyword_id}
                        productKeyWord={product}
                        onSearchChange={onSearchChange}
                        setIsShowSearchDropdown={() =>
                          setIsShowSearchDropdown(false)
                        }
                      />
                    );
                  })}
                </ul>
              </div>
            </div>
          ) : (
            <div
              className={
                isShowSearchDropdown
                  ? "search-dropdown dropdown-show"
                  : "search-dropdown dropdown-hidden"
              }
            >
              {!searchResultListLoading && (
                <div className="list-menu">
                  <ul>
                    <li>No Suggestion found.</li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchProducts;
